/*
*@Author: dcl
*@Description: 加入我们主页
*@Date: 2022-11-14 18:20:26
*/
<template>
<div class="j-box">
    <div class="box-logo">
        <!-- <div class="logo-img"></div> -->
        <!-- <el-image class="logo-img" :src="join_1" fit="cover" /> -->
        <div class="logo-txt">招兵买马 职位等你</div>
    </div>
    <div class="box-sec">
        <div class="sec-title">
            Join us
        </div>
        <div class="sec-left">
            <el-tabs tab-position="left" style="height: 28rem;">
                <el-tab-pane label="职位一">
                    <div class="left-box" v-for="(item, index) in dutyList" :key="index + 'duty'">
                        <div class="box-pot">{{ item.name }}</div>
                        <div class="box-list" v-for="(li, lii) in item.list" :key="lii + 'list'">{{ li }}</div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="职位二">
                    <div class="left-box" v-for="(item, index) in dutyList" :key="index + 'duty'">
                        <div class="box-pot">{{ item.name }}</div>
                        <div class="box-list" v-for="(li, lii) in item.list" :key="lii + 'list'">{{ li }}</div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="职位三">
                    <div class="left-box" v-for="(item, index) in dutyList" :key="index + 'duty'">
                        <div class="box-pot">{{ item.name }}</div>
                        <!-- <el-image class="box-pot" :src="item.name" /> -->
                        <div class="box-list" v-for="(li, lii) in item.list" :key="lii + 'list'">{{ li }}</div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="sec-right">
            <el-image class="right-img1" :src="join_3" fit="cover" />
            <el-image class="right-img2" :src="join_4" fit="cover" />
            <el-image class="right-img3" :src="join_5" fit="cover" />
        </div>
        <!-- <div class="sec-bottom">
            <div class="bottom-title">投递简历</div>
            <div class="bottom-phone">HR电话：020-89686520</div>
            <div class="bottom-email">HR邮箱：dfsi-zhongyt@dfl.com.cn</div>
        </div> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            join_1: require("../../assets/join_1.jpg"),
            join_2: require("../../assets/join_2.png"),
            join_3: require("../../assets/join_3.jpg"),
            join_4: require("../../assets/join_4.jpg"),
            join_5: require("../../assets/join_5.jpg"),
            join_6: require("../../assets/join_6.jpg"),
            join_7: require("../../assets/join_7.png"),
            join_8: require("../../assets/join_8.jpg"),
            join_9: require("../../assets/join_9.jpg"),
            join_10: require("../../assets/join_10.jpg"),
            join_11: require("../../assets/join_11.jpg"),
            join_12: require("../../assets/join_12.jpg"),
            join_13: require("../../assets/join_13.jpg"),
            join_14: require("../../assets/join_14.png"),
            jobsList: ["职位一", "职位二", "职位三"],
            dutyList: [{
                    name: "岗位职责",
                    list: [
                        '暂无招聘信息'
                        // "1、负责所辖分公司日常管理经营工作;",
                        // "2 、协助完成保险产导入并在所辖区域进行推广实施;",
                        // "3 、负责所辖区域行业政策、行业发展趋势等信息的收集;",
                        // "4 、协助完成区域分公司设立并对业务培训、日常管理;"
                    ]
                },
                {
                    name: "任职要求",
                    list: [
                        '暂无招聘信息'
                        // "1、本科及以上学历，审计、法学、保险等相关专业，具有5年以上保险行业相关工作经验的优先考虑;",
                        // "2 、有良好的沟通协调和语言文字表达能力;",
                        // "3 、能独立开展工作，适应能力强，责任心强;"
                    ]
                },
                {
                    name: "福利待遇",
                    list: [
                        '暂无招聘信息'
                        // "1、 13-16年薪，下午茶+进口咖啡+水果+生日礼;",
                        // "2 、免费健身房+公司团队建设活动+节日福利;",
                        // "3 、每年6000元带薪国内或国外的旅行福利;"
                    ]
                },
                {
                    name: "投递简历",
                    list: [
                        "HR电话: 020-89686520",
                        "HR邮箱: dfsi-zhongyt@dfl.com.cn"
                    ]
                }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
.j-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;

    .box-logo {
        // position: relative;
        width: 100%;
        height: 12.47rem;
        // overflow: hidden;
        background: url(../../assets/join_1.jpg) no-repeat center;
        background-size: cover;
        max-width: 1920px;
        position: relative;

        .logo-txt {
            width: 17.33rem;
            height: 2.81rem;
            background: rgba(0, 0, 0, 0.25);
            padding: 0.33rem 2.3rem;
            color: #EDEDED;
            font-size: 2rem;
            position: absolute;
            bottom: 2.77rem;
            left: 10.77rem;
        }

        // .logo-img {
        //     width: 100%;
        //     height: 100%;
        // }
    }

    .box-sec {
        display: flex;
        flex-direction: row;
        width: 100%;
        // justify-content: center;
        // align-self: center;
        max-width: 1920px;
        margin-top: 4rem;
        position: relative;

        .sec-title {
            // margin: 0 3.03rem .27rem;
            font-size: 1.07rem;
            color: #EFF0F2;
            position: absolute;
            top: -1.5rem;
            left: 2rem;
            font-weight: bold;
            width: 6rem;
        }

        .sec-title::before {
            content: '加入我们';
            font-size: 1.13rem;
            font-weight: bold;
            color: #636363;
            position: absolute;
            top: -.87rem;
            // left: 1rem;
            // left: .13rem;
        }

        .sec-left {
            margin-left: 3.66rem;
            // background-color: #b5b8bf;

            // .left-title {
            //     display: flex;
            //     flex-direction: row;
            //     align-items: center;
            //     margin: 20px 20px 5px;

            //     .title-img {
            //         width: 30%;
            //     }

            //     .title-box {
            //         display: flex;
            //         flex-direction: column;

            //         .box-txt {
            //             display: flex;
            //             flex-direction: row;
            //             font-size: 30px;

            //             .txt-txt1 {
            //                 margin-left: 20px;
            //             }

            //             .txt-txt2 {
            //                 color: #79461a;
            //             }
            //         }

            //         .box-list {
            //             display: flex;
            //             flex-direction: row;
            //             justify-content: space-between;
            //             align-content: center;
            //             text-align: center;
            //             margin: 20px 0px 0px 30px;

            //             .list-box {
            //                 color: #2C3E50;
            //                 padding: 3px;
            //                 // border: 1px solid #79461a;
            //             }

            //             .list-box:hover {
            //                 cursor: pointer;
            //             }
            //         }
            //     }
            // }

            .left-box {
                display: flex;
                flex-direction: column;
                align-items: start;
                width: 26.6rem;
                margin: 0px 1.47rem .6rem;
                background-color: #fff;
                padding: .57rem .8rem .7rem;

                .box-pot {
                    line-height: 0.83rem;
                    height: 0.83rem;
                    background-image: linear-gradient(#FFFFFF, #FFF1DD);
                    font-size: 0.65rem;
                    width: 3.67rem;
                    font-weight: bold;
                    margin-bottom: .63rem;
                }

                .box-list {
                    font-size: 0.53rem;
                    word-break: keep-all;
                    line-height: 1.07rem;
                }
            }

            /deep/ .el-tabs__item {
                height: 2.4rem;
                font-size: 0.63rem;
                font-weight: bold;
            }

            /deep/ .el-tabs__item:hover {
                color: #FF9600;
            }

            /deep/ .el-tabs__item.is-active {
                color: #FF9600;
            }

            /deep/ .el-tabs__active-bar {
                background-color: #FF9600;
            }
        }

        .sec-right {
            position: relative;
            width: 100%;
            margin-left: 1.07rem;

            .right-img1 {
                width: 21.08rem;
                height: 11.13rem;
                position: absolute;
                top: 0rem;
                left: 0rem;
            }

            .right-img2 {
                width: 11.33rem;
                height: 7.67rem;
                position: absolute;
                top: 13rem;
                left: 0rem;
            }

            .right-img3 {
                width: 13.07rem;
                height: 12.77rem;
                position: absolute;
                top: 8rem;
                left: 11rem;
            }
        }

        // .sec-bottom {
        //     position: absolute;
        //     left: 10rem;
        //     bottom: 0px;
        //     display: flex;
        //     flex-direction: column;
        //     align-items: start;
        //     max-width: 1920px;
        //     width: 24.2rem;
        //     background-color: #fff;
        //     padding: .57rem .8rem .7rem;

        //     .bottom-title {
        //         line-height: 0.83rem;
        //         height: 0.83rem;
        //         background-image: linear-gradient(#FFFFFF, #FFF1DD);
        //         font-size: 0.65rem;
        //         width: 3.67rem;
        //         font-weight: bold;
        //         margin-bottom: .63rem;
        //     }

        //     .bottom-phone,
        //     .bottom-email {
        //         font-size: 0.53rem;
        //         word-break: keep-all;
        //         line-height: 1.07rem;
        //     }
        // }
    }

}
</style>



// WEBPACK FOOTER //
// src/view/Join/index.vue